import useTracker from '@hooks/useTracker';
import {
  CLICK_START_KYC,
  USER_CLICK_RESEND_EMAIL_VERIFICATION,
  CLICK_STOCK_DETAIL_PAGE,
  CLICK_NEWS,
  VISIT_HOMEPAGE,
  SHOW_PIN_REMINDER,
  CLICK_UPDATE_PIN_6DIGIT,
  CLICK_LATER_PIN_6DIGIT,
} from '@services/trackerConst';

const dashboardProps = {
  'entry point': 'home',
};

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  const eventStartKyc = () => {
    trackEvent(CLICK_START_KYC, dashboardProps);
  };

  const eventClickResendEmailVerify = () => {
    trackEvent(USER_CLICK_RESEND_EMAIL_VERIFICATION);
  };

  const eventClickDetailPageStock = (props) => {
    trackEvent(CLICK_STOCK_DETAIL_PAGE, { ...dashboardProps, ...props });
  };

  const eventClickNews = (props) => {
    trackEvent(CLICK_NEWS, props);
  };

  const eventVisitHomepage = () => {
    trackEvent(VISIT_HOMEPAGE);
  };

  const eventShowPinReminder = () => {
    trackEvent(SHOW_PIN_REMINDER);
  };

  const clickUpdatePin6Digit = () => {
    trackEvent(CLICK_UPDATE_PIN_6DIGIT);
  };

  const clickUpdateLaterPin6Digit = () => {
    trackEvent(CLICK_LATER_PIN_6DIGIT);
  };

  return {
    eventStartKyc,
    eventClickResendEmailVerify,
    eventClickDetailPageStock,
    eventClickNews,
    eventVisitHomepage,
    eventShowPinReminder,
    clickUpdatePin6Digit,
    clickUpdateLaterPin6Digit,
  };
};

export default useEventTracker;
